module.exports = __webpack_public_path__ + "static/media/bpnPreview.5274e0c9.jpg";